import "@babel/polyfill";
import Vue from "vue";
import "./plugins/vuetify";
import "ol/ol.css";
import "chiren/dist/index.css";
import "@/assets/style.styl";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueTour from "vue-tour";
import VueGtag from "vue-gtag";

import "./registerServiceWorker";
import "vue-tour/dist/vue-tour.css";

if (!isCompatible()) {
  document.body.innerHTML =
    "<h1>Colorado Forest Atlas is compatible with the following browsers: Google Chrome, Mozilla Firefox, Microsoft Edge, or Safari.</h1>";
} else {
  Vue.config.productionTip = false;
  Vue.use(VueTour);
  Vue.use(
    VueGtag,
    {
      config: { id: "G-VPGERWEYFZ" },
    },
    router
  );
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
}

function isCompatible() {
  let ua;
  try {
    ua = window.navigator.userAgent;
  } catch (error) {
    return false;
  }
  if (!ua) return false;
  const msie = ua.includes("MSIE ") || ua.includes("Trident/");
  if (msie) return false;
  return true;
}
